import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogTitle, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
type ConfirmSaveDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  isSaving?: boolean;
};
const ConfirmSaveDialog: FC<ConfirmSaveDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  isSaving = false
}) => {
  const {
    t
  } = useTranslation();
  return <Dialog open={open} fullWidth maxWidth="xs" onClose={onClose} data-sentry-element="Dialog" data-sentry-component="ConfirmSaveDialog" data-sentry-source-file="ConfirmSaveDialog.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="ConfirmSaveDialog.tsx">
        <Box sx={{
        bgcolor: "deepOrange.100",
        borderRadius: "100%",
        width: "40px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 1.5
      }} data-sentry-element="Box" data-sentry-source-file="ConfirmSaveDialog.tsx">
          <SaveRoundedIcon color="primary" data-sentry-element="SaveRoundedIcon" data-sentry-source-file="ConfirmSaveDialog.tsx" />
        </Box>
        <Typography variant="inherit" fontWeight={700} flexGrow={0} flexShrink={0} data-sentry-element="Typography" data-sentry-source-file="ConfirmSaveDialog.tsx">
          {t("settings.confirmSaveDialogTitle", {
          title
        })}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{
        mt: 1
      }} data-sentry-element="Typography" data-sentry-source-file="ConfirmSaveDialog.tsx">
          {t("settings.confirmSaveDialogBody")}
        </Typography>
      </DialogTitle>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="ConfirmSaveDialog.tsx">
        <Button variant="text" color="inherit" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="ConfirmSaveDialog.tsx">
          {t("common.cancel")}
        </Button>
        <Button variant="contained" color="primary" startIcon={<SaveRoundedIcon fontSize="small" />} onClick={onConfirm} loading={isSaving} focusRipple autoFocus data-cy="ConfirmSaveSettings" data-sentry-element="Button" data-sentry-source-file="ConfirmSaveDialog.tsx">
          {t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>;
};
export default ConfirmSaveDialog;